import { combineReducers } from 'redux';
import layoutUiReducer from './layoutUiReducer';
import layoutDataReducer from './layoutDataReducer';

export default combineReducers({
  ui: layoutUiReducer,
  data: layoutDataReducer,
});
